import { memo } from 'react';
import { AlertTriangle, CreditCard, X } from 'lucide-react';
import { useCreditsStore } from '../../store/creditsStore';

/**
 * Global low-balance banner.
 *
 * Visibility rules (universal — all roles, no exemption):
 *   - Shows when balance is loaded AND balance < 5.
 *   - Clicking "Cargar créditos" opens the BuyCreditsModal.
 *   - Can be dismissed per-session (state lives in the creditsStore).
 *
 * Copy: "Cargar créditos — Solo pagas lo que usas" (per product spec).
 */
const LowBalanceBanner = memo(() => {
  const balance = useCreditsStore(s => s.balance);
  const bannerDismissed = useCreditsStore(s => s.bannerDismissed);
  const dismissLowBalanceBanner = useCreditsStore(s => s.dismissLowBalanceBanner);
  const openBuyModal = useCreditsStore(s => s.openBuyModal);

  if (balance === null) return null;
  if (balance >= 5) return null;
  if (bannerDismissed) return null;

  const isEmpty = balance <= 0;

  return (
    <div
      className={`lowbal-banner ${isEmpty ? 'empty' : 'low'}`}
      role="alert"
      data-testid="low-balance-banner"
    >
      <AlertTriangle size={16} />
      <div className="lowbal-banner-text">
        <strong>
          {isEmpty
            ? 'Te quedaste sin créditos'
            : `Solo te quedan ${balance} crédito${balance === 1 ? '' : 's'}`}
        </strong>
        <span>Cargar créditos — Solo pagas lo que usas.</span>
      </div>
      <button
        className="lowbal-banner-cta"
        onClick={openBuyModal}
        data-testid="low-balance-banner-cta"
      >
        <CreditCard size={14} />
        Cargar créditos
      </button>
      <button
        className="lowbal-banner-close"
        onClick={dismissLowBalanceBanner}
        title="Ocultar"
        data-testid="low-balance-banner-close"
      >
        <X size={14} />
      </button>
    </div>
  );
});

LowBalanceBanner.displayName = 'LowBalanceBanner';
export default LowBalanceBanner;
